import { build } from "@knyt/weaver";
/**
 * This controller should be added before the host is connected.
 *
 * @alpha This is an experimental API. It will change in future versions.
 */
class GlobalStyleSheetController {
    #styleSheet;
    #styleElement = null;
    #document;
    constructor(styleSheet, options = {}) {
        this.#styleSheet = styleSheet;
        this.#document = options.document ?? globalThis.document;
    }
    async injectStyleSheet() {
        if (this.#styleElement)
            return;
        this.#styleElement = await build(this.#styleSheet.style());
        this.#document.body.appendChild(this.#styleElement);
    }
    removeStyleSheet() {
        if (!this.#styleElement)
            return;
        this.#document.body.removeChild(this.#styleElement);
        this.#styleElement = null;
    }
    hostConnected() {
        this.injectStyleSheet();
    }
    hostDisconnected() {
        this.removeStyleSheet();
    }
}
/**
 * @alpha This is an experimental API. It will change in future versions.
 */
// TODO: Rename for conciseness
export function createGlobalStyleSheetController(styleSheet, options) {
    return new GlobalStyleSheetController(styleSheet);
}
